import { render } from "./PlanCart.vue?vue&type=template&id=5905a048&scoped=true"
import script from "./PlanCart.vue?vue&type=script&lang=js"
export * from "./PlanCart.vue?vue&type=script&lang=js"

import "./PlanCart.vue?vue&type=style&index=0&id=5905a048&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5905a048"]])

export default __exports__